import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addUser, removeUser } from "../utils/userSlice";
import { auth } from "../utils/firebase";
import { LOGO, SUPPORTED_LANGUAGES } from "../utils/constants";
import { toggleGptSearchView } from "../utils/gptSlice";
import { changeLanguage } from "../utils/configSlice";

const Header = () => {
  const navigate = useNavigate();

  const user = useSelector((store) => store.user);
  const dispatch = useDispatch();

  const showGptSearch = useSelector((store) => store.gpt.showGptSearch)

  const handleSignOut = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
      })
      .catch((error) => {
        // An error happened.
        console.log(error)
        navigate("/error");
      });
  };

  useEffect(() => {
   const unsubscribe =  onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/auth.user
        const { uid, email, displayName, photoURL } = user;
        // ...

        dispatch(
          addUser({
            uid: uid,
            email: email,
            displayName: displayName,
            photoURL: photoURL,
          })
        );
        navigate("/browse");
      } else {
        // User is signed out
        // ...
        dispatch(removeUser());
        navigate("/");
      }
    });

    //unsubscribe when component unmounts
    return ()=> unsubscribe();

  },
   []);


   const handleGptSearchClick = () =>{

       dispatch(toggleGptSearchView())

   }

   const handleLanguageChange = (e) => {

     dispatch(changeLanguage(e.target.value));

   }




  return (
    <div className="absolute px-8 py-2 bg-gradient-to-b from-black z-10 w-screen flex flex-col md:flex-row justify-between">
      <img
        className="w-44 mx-auto md:mx-0"
        src={LOGO}
        alt="netflix"
      />

      {user && (
        <div className="flex p-2 justify-between">

        {showGptSearch &&   <select className="p-2 bg-gray-900 text-white m-2" onChange={handleLanguageChange}>

       {SUPPORTED_LANGUAGES.map(lang => 
       
        <option value={lang.indentifier} key={lang.indentifier}>
          {lang.name}
        </option>

       )}

        
       </select>
        }

        <button className="py-2 px-4 mx-4 my-2 bg-purple-800 text-white rounded-lg"
        onClick={handleGptSearchClick}
        >{showGptSearch?"Home": "GPT Search" }</button>
          <img className="hidden md:inline-block w-12 h-12" src={user.photoURL} alt="user" />
          <button onClick={handleSignOut} className="font-bold text-white m-1">
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default Header;
